import React, { useCallback, useMemo, useContext } from 'react'
import useGroomingVisit from '../../../../../hooks/useGroomingVisit'
import OptionsMenu from '../../../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../../../components/SectionFormContainer'
import GroomingAppointmentWizardContext from '../GroomingAppointmentWizardContext'

const MATTED_OPTIONS = [
	{
		label: 'Yes',
		value: 'Yes'
	},
	{
		label: 'No',
		value: 'No'
	},
	{
		label: 'Somewhat',
		value: 'Somewhat'
	},
	{
		label: 'Unsure',
		value: 'Unsure'
	}
]

const MattedSelection = (props) => {
	const {
		wizardContextProvider: { grooming_appointment, setWizardAttributeAndValues }
	} = useContext(GroomingAppointmentWizardContext)
	const { visit_attr, title = '', subtext = '' } = props
	const { loading, facility } = useGroomingVisit()

	const handleSelection = useCallback(
		(type) => {
			const newValues = { ...grooming_appointment }
			newValues[visit_attr] = type
			setWizardAttributeAndValues(newValues)
		},
		[grooming_appointment, setWizardAttributeAndValues, visit_attr]
	)

	const options = useMemo(() => {
		const opts = MATTED_OPTIONS.map(({ label, value }, i) => {
			const option = {
				title: label,
				id: i,
				disabled: loading || grooming_appointment[visit_attr] === value,
				selected: grooming_appointment[visit_attr] === value,
				onSelected: () => handleSelection(value)
			}
			return option
		})

		return opts
	}, [facility, handleSelection, loading, grooming_appointment, visit_attr])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<OptionsMenu options={options} />
		</SectionFormContainer>
	)
}

export default MattedSelection
